export default __webpack_public_path__ + "static/SharpGroteskBookItalic20-Regular-093feab4e09f62dc90645c044ed50ac2.woff2";